<p>
  fatal-error-modal works!
</p>
